import { Weekdays } from 'utils/constants'
import { SocAssessmentQuestionnaireItem } from '../SocAssessment/types/questionnaire'
import { RecertAssessmentQuestionnaireItem } from '../RecertAssessment/types/questionnaire'
import { FuaAssessmentQuestionnaireItem } from '../FuaAssessment/types/questionnaire'
import { RocAssessmentQuestionnaireItem } from '../RocAssessment/types/questionnaire'
import { PatAssessmentQuestionnaireItem } from '../PatAssessment/types/questionnaire'
import { SupervisoryAssessmentQuestionnaireItem } from '../SupervisoryAssessment/types/questionnaire'
import { ServicePlanAssessmentQuestionnaireItem } from '../ServicePlanAssessment/types/questionnaire'
import { DischargeAssessmentQuestionnaireItem } from '../DischargeAssessment/types/questionnaire'

// TODO(ENG-5836): Remove mix of uncontrolled and controlled questionnaire
// items typeswhen we fully migrate to the new SOC assessment
export type SharedCareQuestionnaireItemType =
  | SocAssessmentQuestionnaireItem
  | ServicePlanAssessmentQuestionnaireItem
  | RecertAssessmentQuestionnaireItem
  | FuaAssessmentQuestionnaireItem
  | RocAssessmentQuestionnaireItem

export type AllQuestionnaireItemType =
  | PatAssessmentQuestionnaireItem
  | SocAssessmentQuestionnaireItem
  | ServicePlanAssessmentQuestionnaireItem
  | RecertAssessmentQuestionnaireItem
  | FuaAssessmentQuestionnaireItem
  | DischargeAssessmentQuestionnaireItem
  | RocAssessmentQuestionnaireItem
  | SupervisoryAssessmentQuestionnaireItem

type SharedCareQuestionnaireItemKey = keyof typeof SocAssessmentQuestionnaireItem &
  keyof typeof RecertAssessmentQuestionnaireItem &
  keyof typeof FuaAssessmentQuestionnaireItem &
  keyof typeof RocAssessmentQuestionnaireItem
export interface InterventionInfo {
  id?: number
  category?: string
  interventionGoal?: string
  task?: string
  indication?: string
  type?: string
  instruction?: string
  patientCenteredGoal?: string
  additionalDetails?: string
  visitNumbers?: number[]
  frequency?: string[]
}

// A shared questionnaire item to help us retrieve keys that are common to both
// SOC and Recerts, FUA and ROC
export const SharedCareQuestionnaireItem = (
  key: SharedCareQuestionnaireItemKey
): SharedCareQuestionnaireItemType => {
  // Since the key is shared, we can use either questionnaire item to retrieve the key.
  // In our case, we use the SOC questionnaire item.
  return SocAssessmentQuestionnaireItem[key]
}

export const FuaQuestionnaireItem = (
  key: keyof typeof FuaAssessmentQuestionnaireItem
): FuaAssessmentQuestionnaireItem => {
  return FuaAssessmentQuestionnaireItem[key] as FuaAssessmentQuestionnaireItem
}

export const TASK_FREQUENCIES = Object.values(Weekdays).map((weekday) => weekday)
